import request from "@/utils/request";

export async function getCoinList(postData) {
  return await request({
    url: '/coin-log/list',
    method: "post",
    data: postData,
  });
}
